module.exports = __webpack_public_path__ + "516afa4db060eb313827b21c0b845d3b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-clown.png
// module id = 1897
// module chunks = 0